import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { ProjectorTemplatesEntity } from './projector-templates.models'
import { ProjectorsEntity } from '@galabid/gb-dashboard/projector/data-access'

@Injectable({
  providedIn: 'root',
})
export class ProjectorTemplatesApiService extends GbApiService {
  getProjectorTemplates(): Observable<ProjectorTemplatesEntity[]> {
    return this.get<ProjectorTemplatesEntity[]>('projector-templates/')
  }

  getProjectorTemplate(uuid: string): Observable<ProjectorTemplatesEntity> {
    return this.get<ProjectorTemplatesEntity>(`projector-templates/${uuid}/`)
  }

  updateProjectorTemplate(
    template: Partial<ProjectorTemplatesEntity> & Pick<ProjectorTemplatesEntity, 'uuid'>,
  ): Observable<ProjectorTemplatesEntity> {
    return this.patch<ProjectorTemplatesEntity>(`projector-templates/${template.uuid}/`, template)
  }

  saveProjectorAsTemplate(data: {
    projector: string
    name: string
    schema_version: number
    description: string
    is_public_all_client_accounts: boolean
    client_accounts: string[]
  }): Observable<ProjectorTemplatesEntity> {
    return this.post<ProjectorTemplatesEntity>('projector-templates/save_template/', data)
  }

  createProjectorTemplate(template: Partial<ProjectorTemplatesEntity>): Observable<ProjectorTemplatesEntity> {
    const url = 'projector-templates/'
    return this.post<ProjectorTemplatesEntity>(url, template)
  }

  loadTemplateIntoProjector(params: {
    templateUuid: string
    auctionUrlName: string
    projectorUuid: string
  }): Observable<ProjectorsEntity> {
    const url = `projector-templates/${params.templateUuid}/load_template/`
    return this.post<ProjectorsEntity>(url, {
      auction: params.auctionUrlName,
      projector: params.projectorUuid,
    })
  }
}
